import { render, staticRenderFns } from "./PeriodsCreate.vue?vue&type=template&id=3a5ed324"
import script from "./PeriodsCreate.vue?vue&type=script&lang=js"
export * from "./PeriodsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports